export default {
  common: {
    clearAll: 'Limpar TODOS',
    required: 'Obrigatório',
    restart: 'Reiniciar'
  },
  createUser: {
    acceptTermsAndConditions: 'Aceitar os termos e condições',
    alreadyHaveAccount: 'Já tem uma conta? %{pre}Download%{post}',
    checkEmail: 'Entretanto, descarregue o Metrica Play para o seu computador',
    clubCompany: 'Organização/Clube',
    createdSuccessfully:
      'Registo bem sucedido! Verifique o seu e-mail registado para uma ligação de verificação. (Verifique a pasta de spam)',
    email: 'E-mail',
    invalidEmail: 'E-mail inválido',
    job: 'Cargo/Função',
    lastName: 'Sobrenome',
    name: 'Primeiro nome',
    noCustomOption: 'Opção não disponível',
    noMatches: 'Sem jogos, escreva a sua própria opção',
    password: 'Senha',
    passwordsDontMatch: 'As senhas não coincidem',
    passwordInvalid: 'A senha não cumpre os requisitos',
    passwordRequirements: {
      minLength: 'Pelo menos %{count} caracteres',
      uppercase: 'Uma letra maiúscula',
      lowercase: 'Uma letra minúscula',
      number: 'Um número (0-9)',
      maxLength: 'No máximo %{count} caracteres'
    },
    phone: 'Telefone',
    phoneCode: 'País',
    proceed: 'Proceder',
    repeatPassword: 'Repetir senha',
    searchPhoneCode: 'Pesquisar...',
    seeTermsAndConditions: 'Ver termos e condições',
    signAgreement:
      'Ao se inscrever em uma conta da Metrica Sports, você concorda com a %{pre1}Política de Privacidade%{post1} e os %{pre2}Termos de Serviço%{post2}',
    signUpHere: 'Crie a sua conta para começar.',
    sport: 'Desporto',
    submitting: 'Iniciando…',
    title: 'Comece com %{product}',
    userKeyField: 'Tem um Código Promocional ou uma Chave de Utilizador? Preencha este campo'
  },
  error: {
    downloadPlay: 'Se já tem uma conta, descarregue a última versão do Play e inicie a sessão.',
    emailTaken: 'Este e-mail já foi escolhido',
    fieldTooLong: 'Alguns campos são demasiado longos. Encurte-os e tente novamente',
    oops: 'Oops!',
    restart: 'Parece que está a tentar entrar em algo que ainda estamos a desenvolver...',
    tryAgain:
      'Por favor tente novamente, se este erro continuar, contacte a equipa de apoio da Metrica Sports',
    userKey:
      'A chave não é válida. Verifique a sua chave e tente novamente ou elimine o campo para completar o registo'
  },
  invitation: {
    acceptButton: 'Aceito a Mudança da Minha Conta',
    accepting: 'Aceitando...',
    cancelButton: 'Recusar',
    description1:
      'Quando você for adicionado à nova conta da Metrica Sports, a propriedade da sua conta atual da Metrica Sports (e as informações contidas nela) serão transferidas e atribuídas ao novo proprietário da conta da Metrica Sports. Todas as informações e dados atualmente contidos na sua conta da Metrica Sports, bem como qualquer informação ou dado salvo após você aceitar a mudança de conta, serão visíveis e disponíveis para o novo proprietário da conta da Metrica Sports e para qualquer administrador(es) dessa conta, para usarem e compartilharem com outros a critério do proprietário da conta.',
    description2:
      'Ao clicar em "Aceito a Mudança da Minha Conta", você aceita e autoriza o seguinte:',
    list1:
      'As informações da sua conta atual serão transferidas para a nova conta da Metrica Sports.',
    list2:
      'Todas as informações da conta transferidas para sua nova conta de Metrica Sports da sua conta atual podem ser gerenciadas pelo novo proprietário da conta e/ou administrador(es).',
    list3:
      'Na nova conta da Metrica Sports, seu papel será de “Membro”. Você não terá mais privilégios de proprietário ou administrador da sua conta atual.',
    list4:
      'Você herdará as configurações existentes da sua nova conta de Metrica Sports, que podem ser mais ou menos restritivas dependendo do seu papel na conta, e suas configurações podem ser gerenciadas pelo novo proprietário ou administrador(es) da conta de Metrica Sports.',
    list5:
      'Sua configuração atual poderá ser alterada se entrar em conflito com as configurações da nova conta à qual você está se juntando.',
    list6:
      'É possível que sua nova conta não forneça acesso a todas as funcionalidades que você tem em sua conta atual.',
    list7:
      'Não é possível reverter a transferência da sua conta uma vez que você a inicie, e toda a sua informação de conta permanecerá em uma única conta.',
    list8:
      'Ao clicar em “Aceito a Mudança da Minha Conta”, você se tornará um membro gerenciado da conta de %{pre1}%{email}%{post1} e concorda com os %{pre2}Termos de Serviço%{post2} e a %{pre3}Declaração de Privacidade%{post3} da Metrica Sports.',
    subtitle:
      'Ao aceitar este novo convite de conta da Metrica Sports, você será adicionado a outra conta da Metrica Sports.',
    title: 'Convite'
  },
  jobs: {
    academyDirector: 'Diretor da Academia',
    assistantCoach: 'Treinador Assistente',
    dataAnalyst: 'Analista de Dados',
    doctor: 'Médico',
    formerPlayer: 'Ex-jogador',
    goalkeeperCoach: 'Treinador de Goleiros',
    headCoach: 'Treinador',
    journalist: 'Jornalista',
    other: 'Outros',
    performance: 'Desempenho e Fitness',
    player: 'Jogador',
    scout: 'Scout',
    sportsDirector: 'Diretor Esportivo',
    student: 'Estudante',
    videoAnalyst: 'Analista de Vídeo'
  },
  sports: {
    americanFootball: 'Futebol Americano',
    baseball: 'Basebol',
    basketball: 'Basquetebol',
    fieldHockey: 'Hóquei de campo',
    football: 'Futebol',
    futsal: 'Futsal',
    gaelicFootball: 'Futebol Gaélico',
    handball: 'Andebol',
    iceHockey: 'Hóquei no gelo',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    other: 'Outros',
    padel: 'Padel',
    rugby: 'Râguebi',
    tennis: 'Ténis',
    volleyball: 'Voleibol'
  }
}
